import $ from "jquery";

$(document).ready(function() {
  let elements = $('.content-text a img, .faq-answer a img, .article__item a img, .simplecontactblock a img, .contactblock a img, .lift__degree a img');
  for (let element of elements) {
    $(element).closest('a').css('border-bottom', 'none');
  }
});
